import React, { useEffect, useState } from 'react';
import {
  FormControl,
  OutlinedInput,
  InputAdornment,
  IconButton,
} from '@mui/material';

interface Props {
  searchkey?: string | any;
  placeholder?: string;
  setQuery?: any;
  value?: string;
  sx?: any;
  handleClearSearch?: any;
  className?: any;
  setData?: any;
  setLoading?: any;
  setSearchKey?: any;
  /** Local filter: call setQuery on every change with no debounce (no API). */
  immediate?: boolean;
}

const SearchInput: React.FC<Props> = ({
  placeholder,
  setQuery,
  value = '',
  sx = {},
  handleClearSearch,
  className,
  setData,
  setLoading,
  searchkey,
  setSearchKey,
  immediate,
}) => {
  const [searchQuery, setSearchQuery] = useState<string>(value);
  const [searchTimeout, setSearchTimeout] = useState<any>(null);

  useEffect(() => {
    setSearchQuery(value);
  }, [value]);

  //debounce : search after 500ms of typing
  // const handleSearchChange = (e: any) => {
  //   const trimmedValue = e.target.value.trimStart()

  //   // Prevent setting query with only spaces
  //   if (trimmedValue.length === 0 && e.target.value !== '') {
  //     return
  //   }
  //   clearInterval(searchTimeout)
  //   if (e.target.value.trimStart().length > 2 || searchQuery.length === 0) {
  //     setSearchTimeout(
  //       setTimeout(() => {
  //         setQuery(e.target.value.trimStart())
  //       }, 500)
  //     )
  //   }
  //   if (!e.target.value || searchQuery.length === 0) {
  //     console.log('in if')
  //     updatePaginationPage(1)
  //     if (setData) setData([])
  //     // if (setLoading) setLoading(true)
  //     setSearchTimeout(
  //       setTimeout(() => {
  //         setQuery(e.target.value.trimStart())
  //       }, 500)
  //     )
  //   }
  //   setSearchQuery(e.target.value.trimStart())
  // }

  // const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const trimmedValue = e.target.value.trimStart()

  //   clearTimeout(searchTimeout!)

  //   // **Immediate API call when search is cleared**
  //   if (trimmedValue === '') {
  //     setSearchQuery('')
  //     setSearchKey('')
  //     // setLoading?.(true) // Prevent showing "No Data"
  //     if (setData) {
  //       setData?.([]) // Clear old results
  //     }

  //     setQuery?.('') // Trigger API call
  //     return
  //   }

  //   setSearchQuery(trimmedValue)
  //   setSearchKey(trimmedValue)

  //   // **Debounce API call (500ms)**
  //   setSearchTimeout(
  //     setTimeout(() => {
  //       setQuery?.(trimmedValue)
  //     }, 500)
  //   )
  // }

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value;

    clearTimeout(searchTimeout!);

    const isActuallyCleared = rawValue === ''; // User deleted everything
    const hasMinChars = rawValue.trim().length >= 1; // Trim only for length check

    setSearchQuery(rawValue); // Always keep full value, spaces and all
    setSearchKey(rawValue); // Match the query being typed

    if (immediate) {
      if (isActuallyCleared) {
        setSearchQuery('');
        setSearchKey('');
        setQuery?.('');
        return;
      }
      setQuery?.(rawValue);
      return;
    }

    if (isActuallyCleared) {
      setSearchQuery('');
      setSearchKey('');
      setData?.([]); // Clear old results
      setQuery?.(''); // Trigger API for actual cleared input
      return;
    }

    if (!hasMinChars) {
      // Skip API call if the trimmed value has less than 1 visible char
      return;
    }

    setSearchTimeout(
      setTimeout(() => {
        setQuery?.(rawValue.trim()); // Trim only when sending to the API
      }, 500),
    );
  };

  return (
    <FormControl
      className={`search-field ${className}`}
      fullWidth
      variant="outlined"
    >
      <OutlinedInput
        id="input-with-icon-adornment"
        placeholder={placeholder || 'Search for Studios, Productions...'}
        fullWidth
        value={searchkey}
        onChange={handleSearchChange}
        startAdornment={
          <InputAdornment position="start">
            <i className="search-icon"></i>
          </InputAdornment>
        }
        endAdornment={
          searchkey?.trim().length > 0 && (
            <InputAdornment position="end">
              <IconButton
                onClick={() => {
                  setSearchKey('');
                  setSearchQuery('');
                  handleClearSearch();
                }}
              >
                <i className="cross-icon"></i>
              </IconButton>
            </InputAdornment>
          )
        }
        sx={{
          width: '100%',
        }}
      />
    </FormControl>
  );
};

export default SearchInput;
